import React from 'react'
import { wholesaleHero } from './content'
import type { Lang } from './types'

interface WholesaleHeroV2Props {
  currentLang: Lang
}

/**
 * Full-bleed dark hero with bottom-aligned single big word "Wholesale".
 * SEO H1 is rendered as sr-only above to preserve original keyword signals
 * ("商業豆批發｜營業用咖啡豆專業供應") without competing with the visual title.
 */
const WholesaleHeroV2: React.FC<WholesaleHeroV2Props> = ({ currentLang }) => {
  return (
    <section className="relative h-[70vh] min-h-[480px] w-full overflow-hidden bg-black">
      {/* SEO H1 — invisible, but indexable */}
      <h1 className="sr-only">{wholesaleHero.h1[currentLang]}</h1>

      <div className="absolute inset-0">
        <img
          src={wholesaleHero.image}
          alt={wholesaleHero.imageAlt[currentLang]}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/55 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-12 md:px-10 md:pb-16">
        <div
          className="text-white"
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontWeight: 400,
            fontSize: 'clamp(2.25rem, 5vw, 4rem)',
            letterSpacing: '0.02em',
            lineHeight: 1.1,
          }}
        >
          {wholesaleHero.title[currentLang]}
        </div>
      </div>
    </section>
  )
}

export default WholesaleHeroV2
